const getMediaFromAvatar = (avatarStr) => {
	const newAvatarTypes = ["_dp_", "_dv_", "_cp_", "_cv_"];

	let type = "photo";
	let avatar = avatarStr;
	let isNewAvatar = false;
	for (let index = 0; index < newAvatarTypes.length; index++) {
		const element = newAvatarTypes[index];
		if (avatar.indexOf(element) !== -1) {
			isNewAvatar = true;
			break;
		}
	}

	avatar = avatar.split("/").pop();

	if (avatar.includes("\\")) {
		avatar = avatar.split("\\").pop();
	}

	let splitAvatar = avatar.split("_");
	[avatar] = splitAvatar;

	type = splitAvatar[1].includes("v") ? "video" : "photo";

	if (!isNewAvatar) {
		avatar = avatar.substr(0, avatar.length - 10);
	}
	if (typeof avatar === "string" && avatar !== "") {
		avatar = Number(avatar);
		if (typeof avatar === "number") {
			return {
				avatar: avatar,
				type: !isNewAvatar ? "photo" : type,
			};
		}
	}
};

export default getMediaFromAvatar;
